import React from 'react';
const myContext = React.createContext({});
export default myContext;
